<template>
  <div>
    <Actions
      v-if="rows.length"
      :checkedItems="checkedItems"
      @clearFilters="clearFilters"
      @deleteItems="confirmDeletion"
    />

    <Filters
      v-if="filters"
      :statusList="statusList"
      @resultsPerPage="resultsPerPage"
      @resultsPerStatus="resultsPerStatus"
      @searchKeyword="searchKeyword"
    />

    <Table
      sort
      striped
      bordered
      hover
      :columns="columns"
      :rows="rows"
      @sortColumn="sortColumn"
      @deleteItem="deleteItem"
      @selectItems="selectItems"
    />

    <Pagination
      v-if="paginationItems.length > 1"
      :items="paginationItems"
      :activePage="activePage"
      :rowsCount="totalItems"
      @getPageItem="getPageItem"
    />
  </div>
</template>

<script>
import pagination from '@/utils/pagination'
import Actions from './Actions'
import Filters from './Filters'
import Table from '@/components/table/Table'
import Pagination from '@/components/pagination/Pagination'

export default {
  name: 'DataTable',
  components: { Actions, Filters, Table, Pagination },
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      default: () => []
    },
    totalPages: {
      type: Number,
      // required: true
      default: 1
    },
    totalItems: {
      type: Number,
      // required: true,
      default: 0
    },
    activePage: {
      type: Number,
      // required: true,
      default: 1
    },
    statusList: {
      type: Array,
      default: () => []
    },
    checkedItemsCount: {
      type: Array
    },
    filters: {
      default: true
    }
  },
  watch: {
    checkedItemsCount (to, from) {
      if (to.length === 0) {
        this.checkedItems = []
      }
    },

    $route (to, from) {
      if (to.params.page !== from.params.page) {
        this.checkedItems = []
      }
    }
  },
  computed: {
    paginationItems () {
      return pagination({
        total: this.totalPages,
        activePage: this.activePage
      })
    }
  },

  data () {
    return {
      checkedItems: []
    }
  },

  methods: {
    clearFilters () {
      this.$emit('clearFilters')
    },

    deleteItems (res) {
      this.$emit('confirmDeletion', res)
    },

    resultsPerPage (res) {
      this.$emit('resultsPerPage', res)
    },

    resultsPerStatus (res) {
      this.$emit('resultsPerStatus', res)
    },

    searchKeyword (res) {
      this.$emit('searchKeyword', res)
    },

    sortColumn (res) {
      this.$emit('sortColumn', res)
    },

    deleteItem (res) {
      this.$emit('confirmDeletion', res)
    },

    confirmDeletion (res) {
      this.$emit('confirmDeletion', res)
    },

    selectItems (res) {
      this.checkedItems = res
    },

    getPageItem (res) {
      this.$emit('getPageItem', res)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/datatable/DataTable.vue